import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Clock } from "lucide-react";
import { mediaApi } from "../api";
import MediaCard from "../components/MediaCard";

export default function MediaHistory() {
  const [items, setItems] = useState(null);
  useEffect(() => { mediaApi.history().then(setItems).catch(() => setItems([])); }, []);
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="px-4 md:px-8 lg:px-12 py-12 max-w-[1600px] mx-auto"
      data-testid="media-history-page"
    >
      <div className="flex items-center gap-3 mb-10">
        <Clock className="text-[#D1CFC9]" />
        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-[#D1CFC9] font-bold mb-1">Últimas reproduções</p>
          <h1 className="font-serif text-5xl font-light">Histórico</h1>
        </div>
      </div>
      {items === null ? (
        <div className="live-dot" />
      ) : items.length === 0 ? (
        <div className="text-center py-20 text-slate-400" data-testid="media-history-empty">
          Sem histórico ainda. Reproduz algum conteúdo e volta aqui.
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-6">
          {items.map((i) => <MediaCard key={i.ID_ConteudoMediaCenter} item={i} fluid />)}
        </div>
      )}
    </motion.div>
  );
}
